import React from "react";
import PropTypes from "prop-types";
import { isBreakpoint } from "../utility/WindowSizeHooks"
import PublicCatalogLayout from "../layouts/PublicCatalogLayout"
import ItemCard from "../items/components/ItemCard"
import { isJaguar, isSuperadmin } from "../utility/UserUtils"
import KitCard from "../kits/KitCard";
import InventoryCategorySubheader from "./InventoryCategorySubheader";
import Breadcrumbs from "../layouts/breadcrumbs/Breadcrumbs";
import SuperFilter from "../layouts/superfilter/SuperFilter";
import { isArray } from "jquery";
import AddNewItemButton from "@/layouts/partials/headers/AddNewItemButton";
import ManageInventoryButton from "@/layouts/partials/headers/ManageInventoryButton";

class InventoryCategoryDashboard extends React.Component {

  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      superFilters: [],
    }
  }

  renderItems() {
    let { items, user } = this.props;
    return this.getSortedItems().sort((a,b) => (a.name < b.name ? -1 : 1)).filter(item=> !item.variant_of_id).map(item => (
      <ItemCard key={`item-card-${item.id}`} inventory={true} item={item} user={user}/>
    ))
  }

  renderKits() {
    let { user } = this.props;
    return this.getSortedKits().map(kit => (
      <KitCard inventory={true} kit={kit} user={user}/>
    ))
  }

  getFilteredItems(items) {
    const { superFilters } = this.state;
    let filteredItems = items
    superFilters.forEach(filterObject =>{
      switch(filterObject.filterID){
        case "subcategory":
          if(filterObject.filterValue && isArray(filterObject.filterValue) && filterObject.filterValue.filter(x=>x).length > 0){
            console.log(filterObject.filterValue)
            filteredItems = filteredItems.filter(item => filterObject.filterValue.includes(item.category?.name));
          }
          break;
        case "search":
          if(filterObject.filterValue){
            filteredItems = filteredItems.filter(item => item.name.toLowerCase().includes(filterObject.filterValue.toLowerCase()));
          }
          break;
        default:
          break;
      }
    })
    return filteredItems
  }

  getSortedItems(){
    let { items } = this.props;
    return this.getFilteredItems(items);
  }

  renderSuperFilters() {

    return (
      <SuperFilter
        urlLock={true}
        search={true}
        disableLabel={true}
        onChange={(filters) => {
          this.setState({superFilters: filters});
        }}
        id={`inventory-list-superfilter`}
        lockable
        filters={[
          {
            outerClassName: "sg-super-filter-select-field-option-spacing",
            id: "subcategory",
            type:"multiselect",
            options: 
              this.props.categories.map(category => {
                return {value: category.name, id: category.name, label: category.name}
              })
            ,
            placeholder: "Subcategory",
            name: "Subcategory"
          },
          {
            id: "search",
            type:"search",
            options: [],
            outerClassName: "sg-super-filter-search-field-option-spacing",
            placeholder: "Search",
            name: "Search"
          }
        ]}
      />
    )
  }

  getSortedKits() {
    let { kits } = this.props;
    return kits.sort((a, b) => 
      (a.name < b.name ? -1 : 1)
    )
  }

  getBreadcrumbLinks() {
    const { renter, category, group } = this.props;
    let links = [
      {
        name: `${renter.name} Inventory`,
        url: `/inventory/${renter.id}`
      }
    ]

    if (group) {
      links.push({
        name: group,
        url: `/inventory/${renter.id}/category/${group}`
      })
      if(category) {
        links.push({
          name: category,
          url: `/inventory/${renter.id}/category/${group}/${category}`
        })
      }
    }else {
      links.push({
        name: "All",
        url: `/inventory/${renter.id}/all`
      })
    }

    return links
  }

  render() {
    const { renter, group, user } = this.props;

    return (
      <PublicCatalogLayout
        classNames={{container: 'inventory-dashboard'}}
        className="inventory-dashboard"
        currentGroup={
          group
        }
        currentPage={"inventory-"+renter.id}
        {...this.props}
      >
        <div class="row">
          <div class="col-xs-12">
            <h1 class="catalog-h1">
              {this.props.category ? this.props.category : this.props.group}
              <div
                className="catalog-h1-float-right"
              >
                <AddNewItemButton loadItems={true} user={user} renter={renter} /> 
                <ManageInventoryButton user={user} renter={renter} />
              </div>
            </h1>
          </div>
        </div>
        {this.renderKits()}
        {this.renderSuperFilters()}
        {this.renderItems()}
      </PublicCatalogLayout>
    );
  }
}

InventoryCategoryDashboard.propTypes = {

};

export default InventoryCategoryDashboard;
